export default __webpack_public_path__ + "static/media/picto-vant.72fb04d0.svg";